import { useEffect } from 'react';

function useOnTapOutside(
  element: HTMLElement | null | (HTMLElement | null)[],
  handler: (event: TouchEvent) => void
): void {
  useEffect(() => {
    const listener = (event: TouchEvent) => {
      const elements = Array.isArray(element) ? element : [element];

      for (const e of elements) {
        if (!e || e.contains(event.target as Node)) {
          return;
        }
      }

      handler(event);
    };

    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('touchstart', listener);
    };
  }, [element, handler]);
}

export default useOnTapOutside;
